module.exports = __webpack_public_path__ + "assets/img/ru-34b8499e.png";